import { date_step_closest_shops_heading, date_step_closest_shops_secondary_heading } from '../../lang/da';
import skgIcon from './SG_hex.svg';

const ClosestShops = ({ closestShops, onClick }) => {
    return (
        <div
            className='space-y-4'
        >
            <div
                className="mb-12 mt-16"
            >
                <p
                    className='font-light text-sm md:text-md'
                >
                    {
                        date_step_closest_shops_secondary_heading
                    }
                </p>
                <p
                    className="text-2xl md:text-3xl"
                >
                    {
                        date_step_closest_shops_heading
                    }
                </p>
            </div>
            {
                closestShops.map((closestShop, i) => {
                    return (
                        <div
                            className="shadow-md p-3 flex bg-white items-center"
                            key={i}
                        >
                            <img
                                src={skgIcon}
                                className="w-10 mr-4"
                                alt="skorstensgaard logo"
                            />
                            <div
                                className="flex flex-col md:flex-row flex-1 justify-around"
                            >
                                <div>
                                    <p className="text-skgGray uppercase text-xs tracking-widest">skorstensgaard</p>
                                    <p className="text-md">{closestShop.name}</p>
                                </div>
                                <div>
                                    <p className="text-skgGray uppercase text-xs tracking-widest">næste ledige tid</p>
                                    <p className="text-md">
                                        {closestShop.availabilities.find(a => a.m_capacity < 0.8 && !a.closed).date}
                                    </p>
                                </div>
                            </div>
                            <button
                                className="ml-auto bg-skgBlue text-white py-2 px-4 rounded-md text-md"
                                onClick={() => onClick(closestShop)}
                            >
                                {`Skift`}
                            </button>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default ClosestShops;